import React from "react";
import { Routes, Route } from "react-router-dom";
import ScrollTop from "./shell/ScrollTop";
import Home from "./app/Home";
import Services from "./app/Services";
import Service from "./app/Service";
import Work from "./app/Work";
import About from "./app/About";
import Contact from "./app/Contact";
import NotFound from "./app/NotFound";

const App = () => (
  <ScrollTop>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<Service />} />
      <Route path="/work" element={<Work />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </ScrollTop>
);

export default App;
